export interface TeamLogo {
  name: string;
  logoUrl: string;
  alt: string;
}

export interface PlayerImage {
  name: string;
  team: string;
  imageUrl: string;
  position?: string;
}

export interface AssetConfig {
  teamLogos: TeamLogo[];
  playerImages: PlayerImage[];
  backgroundImages: {
    heroBackground?: string;
    playersBackground?: string;
  };
}

export const assetConfig: AssetConfig = {
  teamLogos: [
    { name: 'Racing Ferrol', logoUrl: '/logos/1.png', alt: 'Racing Ferrol' },
    { name: 'Cultural Leonesa', logoUrl: '/logos/2.png', alt: 'Cultural Leonesa' },
    { name: 'Real Zaragoza', logoUrl: '/logos/3.png', alt: 'Real Zaragoza' },
    { name: 'Córdoba CF', logoUrl: '/logos/4.png', alt: 'Córdoba CF' },
    { name: 'Levante UD', logoUrl: '/logos/5.png', alt: 'Levante UD' },
    { name: 'Málaga CF', logoUrl: '/logos/6.png', alt: 'Málaga CF' },
    { name: 'CD Eldense', logoUrl: '/logos/7.png', alt: 'CD Eldense' },
    { name: 'Real Valladolid', logoUrl: '/logos/8.png', alt: 'Real Valladolid' },
    { name: 'CD Mirandés', logoUrl: '/logos/9.png', alt: 'CD Mirandés' },
    { name: 'Deportivo La Coruña', logoUrl: '/logos/10.png', alt: 'Deportivo La Coruña' },
    { name: 'Albacete Balompié', logoUrl: '/logos/11.png', alt: 'Albacete Balompié' },
    { name: 'SD Eibar', logoUrl: '/logos/12.png', alt: 'SD Eibar' },
    { name: 'Cádiz CF', logoUrl: '/logos/13.png', alt: 'Cádiz CF' },
    { name: 'Burgos CF', logoUrl: '/logos/14.png', alt: 'Burgos CF' },
    { name: 'CD Castellón', logoUrl: '/logos/15.png', alt: 'CD Castellón' },
    { name: 'Elche CF', logoUrl: '/logos/16.png', alt: 'Elche CF' },
    { name: 'Real Sporting', logoUrl: '/logos/17.png', alt: 'Real Sporting' },
    { name: 'SD Huesca', logoUrl: '/logos/18.png', alt: 'SD Huesca' },
    { name: 'Granada CF', logoUrl: '/logos/19.png', alt: 'Granada CF' },
    { name: 'Real Oviedo', logoUrl: '/logos/20.png', alt: 'Real Oviedo' },
    { name: 'CD Tenerife', logoUrl: '/logos/21.png', alt: 'CD Tenerife' },
    { name: 'Cartagena FC', logoUrl: '/logos/22.png', alt: 'Cartagena FC' },
  ],
  
  playerImages: [
    { name: 'Lionel Messi', team: 'PSG', imageUrl: '/players/messi.jpg', position: 'Forward' },
    { name: 'Karim Benzema', team: 'Real Madrid', imageUrl: '/players/benzema.jpg', position: 'Forward' },
    { name: 'Robert Lewandowski', team: 'Barcelona', imageUrl: '/players/lewandowski.jpg', position: 'Forward' },
    { name: 'Luka Modric', team: 'Real Madrid', imageUrl: '/players/modric.jpg', position: 'Midfielder' },
    { name: 'Pedri', team: 'Barcelona', imageUrl: '/players/pedri.jpg', position: 'Midfielder' },
    { name: 'Vinicius Jr.', team: 'Real Madrid', imageUrl: '/players/vinicius.jpg', position: 'Forward' },
    { name: 'Gavi', team: 'Barcelona', imageUrl: '/players/gavi.jpg', position: 'Midfielder' },
    { name: 'Rodrygo', team: 'Real Madrid', imageUrl: '/players/rodrygo.jpg', position: 'Forward' },
    { name: 'Ansu Fati', team: 'Barcelona', imageUrl: '/players/fati.jpg', position: 'Forward' },
    { name: 'Eder Militao', team: 'Real Madrid', imageUrl: '/players/militao.jpg', position: 'Defender' },
    { name: 'Ronald Araujo', team: 'Barcelona', imageUrl: '/players/araujo.jpg', position: 'Defender' },
    { name: 'Thibaut Courtois', team: 'Real Madrid', imageUrl: '/players/courtois.jpg', position: 'Goalkeeper' },
    { name: 'Marc-André ter Stegen', team: 'Barcelona', imageUrl: '/players/terstegen.jpg', position: 'Goalkeeper' },
    { name: 'David Alaba', team: 'Real Madrid', imageUrl: '/players/alaba.jpg', position: 'Defender' },
    { name: 'Gerard Piqué', team: 'Barcelona', imageUrl: '/players/pique.jpg', position: 'Defender' },
    { name: 'Casemiro', team: 'Manchester United', imageUrl: '/players/casemiro.jpg', position: 'Midfielder' },
  ],
  
  backgroundImages: {
    heroBackground: '/backgrounds/background-1.png',
    playersBackground: '/backgrounds/background-2.png',
  }
};